import React from "react";
import { useTranslation } from "src/context/Translations/context";
import LoginScreen from "src/components/LoginScreen";
import { useParams } from "react-router-dom";
import useEffectFetchData from "src/hooks/useEffectFetchData";
import Loader from "src/components/Loader";
import Title from "src/components/Title";
import { useAuth } from "src/context/Auth/context";
import { IUsersInvite } from "./interface";
import FormUserInvite from "./FormUserInvite";

const UsersInvitePage: React.FC = () => { 
	const { translate } = useTranslation();
	const { user } = useAuth();
	const params = useParams<{
        key: string;
    }>();
	
	const {data , loading, errorFetching } = useEffectFetchData<IUsersInvite> (
		"UserPublic/GetInvite", 
		{ key: params.key }
	);

	return (
		<LoginScreen
			contentPosition="start"
			style={user ? {
				height: "calc(100vh - 96px)"
			}: {}}
		>
			{errorFetching ? <Title color="defaultColor">{translate("Esse convite está inválido")}.</Title>: 
				<>
					{loading ? 
						<Loader /> : 
						<>
							{!data || data === null ? <Title color="defaultColor">{translate("O link desse convite está inválido")}.</Title>: <FormUserInvite data={data} />}
						</>}
				</>}
		</LoginScreen>					
	);
};

export default UsersInvitePage;
